export const NO_CONTENT = [
    'oven',
    'mixer',
    'cooking-pot',
    'bag',
    // 'glove'
];
